import {
  ElementProps,
  ActionIcon as RawActionIcon,
  ActionIconProps as RawActionIconProps,
} from '@mantine/core';
import colors, { ColorVariantType } from 'common/constants/colors.styles';
import React from 'react';
import { PredefinedFirst } from 'types/helper.type';

export type MantineActionIconSize = RawActionIconProps['size'];

export interface ActionIconProps
  extends Omit<RawActionIconProps, 'color'>,
    ElementProps<'button', keyof RawActionIconProps> {
  isResponsive?: boolean;
  color?: PredefinedFirst<ColorVariantType>;
}

export default function ActionIcon(props: ActionIconProps) {
  const {
    type = 'button',
    size = 'md',
    color: _color = 'blue',
    ...rest
  } = props;

  const color = React.useMemo(() => {
    return colors?.[_color] || _color;
  }, [_color]);

  return <RawActionIcon type={type} size={size} color={color} {...rest} />;
}
